import classNames from "classnames";
import { useId } from "react";
import { TooltipTemplate } from "UiKit/Tooltips";
import styles from "./ChipTemplate.module.css";
import React from "react";
function ChipTemplate({ onClick, tooltipMessage, tooltipPosition = "top", children, isLoading = false, isError, isActive, disable, className, classNameContent, classNamesStateLayer, href, ...props }) {
    const id = useId();
    const onClickButton = (e) => {
        if (onClick) {
            e.stopPropagation();
            onClick(e);
        }
    };
    const content = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles["state-layer"], classNamesStateLayer) },
            React.createElement("div", { className: classNames(styles.content, classNameContent) }, children)),
        tooltipMessage && (React.createElement(TooltipTemplate, { id: id, position: tooltipPosition },
            React.createElement("span", null, tooltipMessage)))));
    return href ? (React.createElement("a", { id: id, className: classNames(styles.template, className), onClick: onClickButton, "data-disabled": isLoading || disable, "data-loading": isLoading, "data-error": isError, "data-active": isActive, href: href, ...props }, content)) : (React.createElement("div", { id: id, className: classNames(styles.template, className), onClick: onClickButton, "data-disabled": isLoading || disable, "data-loading": isLoading, "data-error": isError, "data-active": isActive, ...props }, content));
}
export default ChipTemplate;
